import { render, staticRenderFns } from "./CallsList.vue?vue&type=template&id=4c8e732b&scoped=true&"
import script from "./CallsList.vue?vue&type=script&lang=ts&"
export * from "./CallsList.vue?vue&type=script&lang=ts&"
import style0 from "./CallsList.vue?vue&type=style&index=0&id=4c8e732b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8e732b",
  null
  
)

export default component.exports